var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 14,
    rx: 7,
    fill: "#F0B741"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.976 3.718V10h-1.26V7.327h-2.69V10h-1.26V3.718h1.26v2.583h2.69V3.718h1.26zm4.158 6.345q-.882 0-1.62-.414-.737-.414-1.17-1.147-.431-.734-.431-1.661 0-.918.431-1.652.433-.733 1.17-1.147.739-.414 1.62-.414.891 0 1.625.414.733.414 1.161 1.147.427.734.427 1.652 0 .927-.427 1.66-.428.734-1.166 1.148-.737.414-1.62.414zm0-1.125q.567 0 1-.257.431-.256.675-.733.243-.477.243-1.107t-.243-1.103q-.243-.472-.675-.724-.433-.252-1-.252-.566 0-1.003.252-.437.252-.68.724-.242.473-.242 1.103t.242 1.107q.243.477.68.733.437.257 1.003.257zm8.424-5.22v1.017h-1.674V10h-1.26V4.735H17.95V3.718h4.608z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHot);
export default __webpack_public_path__ + "static/media/icon-hot.bf32bac2.svg";
export { ForwardRef as ReactComponent };